import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";
import AuthModal from "./AuthModal";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setAuthLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const showAuthModal = (mode = "login") => {
    setAuthMode(mode);
    setAuthModalOpen(true);
  };

  const hideAuthModal = () => setAuthModalOpen(false);

  const logout = async () => {
    try {
      await signOut(auth);
      setUser(null); // Clear user after signing out
    } catch (error) {
      console.error("Sign out error:", error);
    }
  };

  return (
    <AuthContext.Provider
      value={{ user, authLoading, showAuthModal, hideAuthModal, logout }}
    >
      {children}
      <AuthModal
        isOpen={authModalOpen}
        onClose={hideAuthModal}
        mode={authMode}
        onSwitchMode={setAuthMode}
      />
    </AuthContext.Provider>
  );
};
